import React from 'react';
import PaginationContext from "./context";

const pullProperty = (key, props) => {
    props = Object.assign({}, props);

    const value = props[key];
    delete props[key];

    if (value) {
        // Only finish if we got a value.
        return {value, props};
    }

    throw new Error(`Paginator can not pull '${key}' from component properties.`);
};

const withPaginator = (key) => (WrappedComponent) => {
    return class WithPaginator extends React.Component {
        render() {
            const {value, props} = pullProperty(key, this.props);
            return props.months && props.months.length ? (
                <WrappedComponent
                    items={value}
                    {...props}
                />
            ):(
                <PaginationContext.Provider value={value}>
                    <WrappedComponent
                        items={value.data}
                        {...props}
                    />
                </PaginationContext.Provider>
            );
        }
    };
};

export default withPaginator;
